<template>
  <div id="video" class="page-slide">
    <video id="video-demo" controls>
      <source src="assets/videos/f8th.mp4" type="video/mp4" />
      <track v-for="l in langs" :key="l.id" :label="l.label" kind="subtitles" :srclang="l.id" :src="`assets/videos/f8th-${l.id}.vtt`" :mode="l.id === lang.id ? 'showing' : 'disabled'">
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PageSlideVideo",
  components: {},
  computed: {
    ...mapGetters("languages", ["lang", "langs"])
  }
};
</script>

<style lang="scss" scoped>
#video-demo {
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
}
::cue(.red){
  margin-bottom: 40vh;
}
</style>
